export const InvoicingMethod = {
  Email: 'Email',
  EInvoice: 'EInvoice',
  Paper: 'Paper'
};

export const FormArrays = {
  ContactPersons: 'contactPersons'
};

export const FormFields = {
  AcceptTerms: 'acceptTerms',
  ActiveBenefits: 'activeBenefits',
  AdditionalMessage: 'additionalMessage',
  Address: 'address',
  AddressId: 'addressId',
  AddressLine: 'addressLine',
  Benefit: 'benefit',
  BenefitGroupIds: 'BenefitGroupIds',
  BenefitGroupId: 'benefitGroupId',
  GroupId: 'groupId',
  Benefits: 'benefits',
  BeneficiariesAmount: 'beneficiariesAmount',
  BusinessId: 'businessId',
  CheckableEmployees: 'checkableEmployees',
  City: 'city',
  CostCenterNumber: 'costCenter',
  Columns: 'columns',
  CompanyName: 'companyName',
  ConfirmPassword: 'confirmPassword',
  CopyCompanyAddress: 'copyCompanyAddress',
  CopyContactPerson: 'copyContactPerson',
  Country: 'country',
  CustomerNumber: 'customerNumber',
  CreatedAt: 'createdAt',
  DataScope: 'dataScope',
  DaysForLunari: 'DaysForLunari',
  DeliveryMethod: 'deliveryMethod',
  DeliveryAddress: 'deliveryAddress',
  DeliveryCity: 'deliveryCity',
  DeliveryCompanyName: 'deliveryCompanyName',
  DeliveryCountry: 'deliveryCountry',
  DeliveryZipCode: 'deliveryZipCode',
  EditMode: 'EditMode',
  EditingType: 'editing',
  EmployeeNumber: 'employeeNumber',
  EmployeeType: 'EmploymentType',
  EmployeePercentage: 'EmployeePercentage',
  EndOfBenefit: 'endOfBenefit',
  EndOfFunds: 'endOfFunds',
  Entitled: 'entitled',
  DownloadAs: 'downloadAs',
  EInvoice: 'eInvoice',
  EInvoiceAddress: 'eInvoiceAddress',
  EInvoiceOperator: 'operator',
  EmailAddress: 'emailAddress',
  EmployeeData: 'employeeData',
  EndDate: 'endDate',
  FirstName: 'firstName',
  FromMonth: 'fromMonth',
  FirstSlideoutOpen: 'FirstSlideoutOpen',
  IncomeRegister: 'incomeRegister',
  InvoicingContactPerson: 'invoicingContactPerson',
  InvoicingCostCenter: 'invoicingCostCenter',
  InvoicingEmailAddress: 'invoicingEmailAddress',
  InvoicingMethod: 'invoicingMethod',
  JobTitle: 'jobTitle',
  KeepLoggedIn: 'keepLoggedIn',
  LastName: 'lastName',
  Loads: 'loads',
  LoadStatuses: 'loadStatuses',
  LunchBenefitActive: 'lunchBenefitActive',
  NewPassword: 'newPassword',
  MoneyAmount: 'moneyAmount',
  NumberOfEmployees: 'numberOfEmployees',
  Operator: 'operator',
  Other: 'other',
  Page: 'page',
  Password: 'password',
  Payroll: 'payroll',
  PaymentMethod: 'paymentMethod',
  PaymentMethodCode: 'paymentMethodCode',
  PhoneNumber: 'phoneNumber',
  PendingLoadDate: 'pendingLoadDate',
  PersonID: 'personId',
  PersonalID: 'personalId',
  PickerStartDate: 'pickerStartDate',
  PickerEndDate: 'pickerEndDate',
  PostCode: 'postCode',
  RightToSign: 'rightToSign',
  RequestDownloadReport: 'requestDownloadReport',
  Report: 'report',
  SelectedID: 'selectedId',
  StartDate: 'startDate',
  ScheduleType: 'scheduleType',
  ScheduleDate: 'scheduleDate',
  ToMonth: 'toMonth',
  Username: 'username',
  UsernameOrEmail: 'usernameOrEmail',
  ValidateCompanyInformation: 'validateCompanyInformation',
  VoucherId: 'voucherId',
  VoucherQuantity: 'voucherQuantity',
  VoucherWorth: 'voucherWorth',
  WageType: 'wageType',
  WithoutReferenceNumber: 'withoutReferenceNumber',
  ZipCode: 'zipCode'
} as const;

export function withFormNameContext(context: string, name: string) {
  return context ? `${context}.${name}` : name;
}
